module.exports = __webpack_public_path__ + "img/9788952223852.808c543e.jpg";